import script from "./TempSettingListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TempSettingListPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__